"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var Grid_1 = __importDefault(require("../../../Grid"));

var styled_1 = require("../selects/Select/styled");

var Styled_1 = require("../TextInput/Styled");

exports.PhoneWrapper = styled_components_1.default(Grid_1.default.Container)(function (props) {
  var _a;

  return _a = {
    position: 'relative'
  }, _a[styled_1.SelectBox] = {
    borderRightWidth: 0
  }, _a[styled_1.SelectIcon] = {
    borderLeftWidth: 0
  }, _a[styled_1.SelectWrapper] = {
    position: 'initial'
  }, _a[Styled_1.StyledTextInput] = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }, _a;
});